// templates
export const UPLOAD_TEMPLATE = 'app/Reports/UPLOAD_TEMPLATE'
export const UPLOAD_TEMPLATE_DONE = 'app/Reports/UPLOAD_TEMPLATE_DONE'
export const UPLOAD_TEMPLATE_ERROR = 'app/Reports/UPLOAD_TEMPLATE_ERROR'
export const CANCEL_UPLOAD_TEMPLATE = 'app/Reports/CANCEL_UPLOAD_TEMPLATE'
export const SET_UPLOAD_TEMPLATE_CANCEL =
  'app/Reports/SET_UPLOAD_TEMPLATE_CANCEL'

export const GET_TEMPLATES = 'app/Reports/GET_TEMPLATES'
export const GET_TEMPLATES_DONE = 'app/Reports/GET_TEMPLATES_DONE'
export const GET_TEMPLATES_ERROR = 'app/Reports/GET_TEMPLATES_ERROR'
export const CLEAR_REPORT_TEMPLATES = 'app/Reports/CLEAR_REPORT_TEMPLATES'

export const GET_TEMPLATES_MANAGEMENT = 'app/Reports/GET_TEMPLATES_MANAGEMENT'
export const GET_TEMPLATES_MANAGEMENT_DONE =
  'app/Reports/GET_TEMPLATES_MANAGEMENT_DONE'
export const GET_TEMPLATES_MANAGEMENT_ERROR =
  'app/Reports/GET_TEMPLATES_MANAGEMENT_ERROR'
export const CLEAR_REPORT_TEMPLATES_MANAGEMENT =
  'app/Reports/CLEAR_REPORT_TEMPLATES_MANAGEMENT'

export const UPDATE_TEMPLATE = 'app/Reports/UPDATE_TEMPLATE'
export const UPDATE_TEMPLATE_DONE = 'app/Reports/UPDATE_TEMPLATE_DONE'
export const UPDATE_TEMPLATE_ERROR = 'app/Reports/UPDATE_TEMPLATE_ERROR'

export const FORMAT_TEMPLATE_ERRORS = 'app/Reports/FORMAT_TEMPLATE_ERRORS'

export const CLEAR_UPDATE_TEMPLATE_STORE =
  'app/Reports/CLEAR_UPDATE_TEMPLATE_STORE'

export const DELETE_TEMPLATES = 'app/Reports/DELETE_TEMPLATES'
export const DELETE_TEMPLATES_DONE = 'app/Reports/DELETE_TEMPLATES_DONE'
export const DELETE_TEMPLATES_ERROR = 'app/Reports/DELETE_TEMPLATES_ERROR'

export const GET_TEMPLATES_PROJECTS = 'app/Reports/GET_TEMPLATES_PROJECTS'
export const GET_TEMPLATES_PROJECTS_DONE =
  'app/Reports/GET_TEMPLATES_PROJECTS_DONE'
export const GET_TEMPLATES_PROJECTS_ERROR =
  'app/Reports/GET_TEMPLATES_PROJECTS_ERROR'
export const CLEAR_TEMPLATES_PROJECTS_ERROR =
  'app/Reports/CLEAR_TEMPLATES_PROJECTS_ERROR'

export const ASSIGN_TEMPLATES_TO_PROJECT =
  'app/Reports/ASSIGN_TEMPLATES_TO_PROJECT'
export const ASSIGN_TEMPLATES_TO_PROJECT_DONE =
  'app/Reports/ASSIGN_TEMPLATES_TO_PROJECT_DONE'
export const ASSIGN_TEMPLATES_TO_PROJECT_ERROR =
  'app/Reports/ASSIGN_TEMPLATES_TO_PROJECT_ERROR'

// reports
export const GET_REPORTS = 'app/Reports/GET_REPORTS'
export const GET_REPORTS_DONE = 'app/Reports/GET_REPORTS_DONE'
export const GET_REPORTS_ERROR = 'app/Reports/GET_REPORTS_ERROR'
export const CLEAR_REPORTS = 'app/Reports/CLEAR_REPORTS'

export const CREATE_REPORT = 'app/Reports/CREATE_REPORTS'
export const CREATE_REPORT_DONE = 'app/Reports/CREATE_REPORTS_DONE'
export const CREATE_REPORT_ERROR = 'app/Reports/CREATE_REPORTS_ERROR'
export const CREATE_REPORT_CANCEL = 'app/Reports/CREATE_REPORT_CANCEL'

export const GET_CREATED_REPORT = 'app/Reports/GET_CREATED_REPORT'
export const GET_CREATED_REPORT_DONE = 'app/Reports/GET_CREATED_REPORT_DONE'
export const GET_CREATED_REPORT_ERROR = 'app/Reports/GET_CREATED_REPORT_ERROR'
export const DELETE_CREATED_REPORT = 'app/Reports/DELETE_CREATED_REPORT'

export const ENABLE_SHARE_REPORT = 'app/Reports/ENABLE_SHARE_REPORT'
export const ENABLE_SHARE_REPORT_DONE = 'app/Reports/ENABLE_SHARE_REPORT_DONE'
export const ENABLE_SHARE_REPORT_ERROR = 'app/Reports/ENABLE_SHARE_REPORT_ERROR'
export const CLEAR_SHARE_REPORT_ERROR = 'app/Reports/CLEAR_SHARE_REPORT_ERROR'

export const GET_TEMPLATES_OF_PROJECT_MANAGEMENT =
  'app/Reports/GET_TEMPLATES_OF_PROJECT_MANAGEMENT'
export const GET_TEMPLATES_OF_PROJECT_MANAGEMENT_DONE =
  'app/Reports/GET_TEMPLATES_OF_PROJECT_MANAGEMENT_DONE'
export const GET_TEMPLATES_OF_PROJECT_MANAGEMENT_ERROR =
  'app/Reports/GET_TEMPLATES_OF_PROJECT_MANAGEMENT_ERROR'
export const CLEAR_REPORT_TEMPLATES_OF_PROJECT_MANAGEMENT =
  'app/Reports/CLEAR_REPORT_TEMPLATES_OF_PROJECT_MANAGEMENT'

export const GET_DETAILED_PROJECT_PINS = 'app/Reports/GET_DETAILED_PROJECT_PINS'
export const CLEAR_DETAILED_PINS = 'app/Reports/CLEAR_DETAILED_PINS'
export const GET_DETAILED_PINS_DONE = 'app/Reports/GET_DETAILED_PINS_DONE'
export const GET_DETAILED_PINS_ERROR = 'app/Reports/GET_DETAILED_PINS_ERROR'

export const CREATE_FILTER = 'app/Reports/CREATE_FILTER'
export const CREATE_FILTER_DONE = 'app/Reports/CREATE_FILTER_DONE'
export const CREATE_FILTER_ERROR = 'app/Reports/CREATE_FILTER_ERROR'

export const GET_ATTENDEES_LIST = 'app/Reports/GET_ATTENDEES_LIST'
export const GET_ATTENDEES_LIST_DONE = 'app/Reports/GET_ATTENDEES_LIST_DONE'
export const GET_ATTENDEES_LIST_ERROR = 'app/Reports/GET_ATTENDEES_LIST_ERROR'

export const GET_WEATHER_DATE = 'app/Reports/GET_WEATHER_DATE'
export const GET_WEATHER_DATE_DONE = 'app/Reports/GET_WEATHER_DATE_DONE'
export const GET_WEATHER_DATE_ERROR = 'app/Reports/GET_WEATHER_DATE_ERROR'

export const templatePlaceholders = {
  ATTENDEES_FIELD: 'AttendeesField',
  WEATHER: 'WeatherField'
}

export const viewTypes = {
  reports: 'reports',
  templates: 'templates'
}

export const REPORT_BASIS = (formatMessage) => [
  { value: 'Pins', label: formatMessage({ id: 'pins' }) },
  { value: 'Tasks', label: formatMessage({ id: 'tasks' }) }
]
export const BASE_URL = {
  development: 'https://www.dev.docu-tools.com',
  staging: 'https://www.dev.docu-tools.com',
  production: 'https://www.clouds.docu.solutions'
}